import moment from "moment";

export const formatTime = seconds => {
	const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
	const secs = String(seconds % 60).padStart(2, "0");
	return `00:${mins}:${secs}`;
};

export const getFilteredPersonnel = (personnel, searchTerm) => {
	const normalize = str =>
		String(str || "")
			.toLowerCase()
			.trim()
			.replace(/\s+/g, " "); // collapse multiple spaces

	const q = normalize(searchTerm);
	if (!q) return personnel;

	return personnel.filter(p => {
		const fullName = normalize([p.firstName, p.middleName, p.lastName].filter(Boolean).join(" "));

		return fullName.includes(q);
	});
};

export const initializeEvacuationTimer = (
	startTimeISO,
	timer,
	timerUnit,
	setTimeLeft,
	setShowPrintRequired,
	setEvacuationStarted
) => {
	if (!startTimeISO) return;

	const startTime = moment.utc(startTimeISO);
	const now = moment.utc();
	const elapsed = now.diff(startTime, "seconds");

	let totalDuration;
	switch (timerUnit) {
		case "seconds":
			totalDuration = timer;
			break;
		case "minutes":
			totalDuration = timer * 60;
			break;
		case "hours":
			totalDuration = timer * 60 * 60;
			break;
		default:
			totalDuration = timer * 60;
	}

	const remaining = Math.max(0, totalDuration - elapsed);

	if (remaining <= 0) {
		setShowPrintRequired(true);
	}
	setTimeLeft(remaining);
	setEvacuationStarted(true);
};

// utils/timer.js or inline above the component
export const startEvacuationCountdown = (evacuationStarted, timeLeft, setTimeLeft, setIsPrintRequired) => {
	if (!evacuationStarted || timeLeft <= 0) return;

	const interval = setInterval(() => {
		setTimeLeft(prev => {
			if (prev <= 1) {
				clearInterval(interval);
				setIsPrintRequired(true);
				return 0;
			}
			return prev - 1;
		});
	}, 1000);

	return () => clearInterval(interval);
};
